import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import EToolTip from '../others/EToolTip';
import SolarIcon from 'components/icons/SolarIcon';
import ListColumnsMenu, { type ListColumnItem } from './ListColumnsMenu';

export interface ListToolBarColumns {
    items: ListColumnItem[];
    onToggle: (id: string) => void;
}

interface ListToolBarActionsProps {
    onReset: () => void;
    onRefresh: () => void;
    className?: string;
    columns?: ListToolBarColumns;
}

const ListToolBarActions = ({
    onReset,
    onRefresh,
    className = '',
    columns,
}: ListToolBarActionsProps) => {
    const { t } = useTranslation('common');

    const handleClick = (fn: () => void) => (e: React.MouseEvent<HTMLButtonElement>) => {
        e.currentTarget.blur();
        fn();
    };

    return (
        <>
            {columns && columns.items.length > 0 ? (
                <ListColumnsMenu
                    className={className}
                    items={columns.items}
                    onToggle={columns.onToggle}
                />
            ) : null}

            <EToolTip title={t('toolRefreshList')}>
                <span className={`d-inline-block ${className}`}>
                    <Button
                        className="fs-14 px-2 toolbar-icon-btn"
                        size="sm"
                        onClick={handleClick(onRefresh)}
                    >
                        <SolarIcon name="arrow-clockwise" className="fs-14 p-0" />
                    </Button>
                </span>
            </EToolTip>

            <EToolTip title={t('toolResetList')}>
                <span className={`d-inline-block ${className}`}>
                    <Button
                        className="fs-14 px-2 toolbar-icon-btn"
                        size="sm"
                        onClick={handleClick(onReset)}
                    >
                        <SolarIcon name="arrow-counterclockwise" className="fs-14 p-0" />
                    </Button>
                </span>
            </EToolTip>
        </>
    );
};

export default ListToolBarActions;
